import Http from "../../services/HTTP";
const LOGIN_USER = "LOGIN_USER";

// login to admin panel starts here
function loginWaiting() {
    return {
        type : LOGIN_USER,
        login_waiting : true,
        login_response : {},
        login_error : {}
    }
}

function loginSuccess(response) {
    return {
        type: LOGIN_USER,
        login_waiting : false,
        login_response : response,
        login_error : {}
    }
}

function loginEmpty() {
    return {
        type: LOGIN_USER,
        login_waiting : false,
        login_response : {},
        login_error : {}
    }
}

function loginError(error) {
    return {
        type : LOGIN_USER,
        login_waiting : false,
        login_response : {},
        login_error : error
    }
}

function login(data) {
    return (dispatch) => {
        dispatch(loginWaiting());
        const get = Http.POST('pharmacy/v1/auth/login',data);
        get.then((response) => {
            if (response !== undefined)
                dispatch(loginSuccess(response));
        }).catch((error) => {
            dispatch(loginError(error));
        });
    }
}
// getting VerificationCode for admin panel ends here

export {
    LOGIN_USER,
    login,
    loginEmpty
}
